module.exports = __webpack_public_path__ + "img/zoom-logo.c4680efa.png";